<template>
	<div class="guanyubody">
		<div class="w guanyuPage">
			<div class="gy-left">
				<nuxt-link to="../guanyu">
					<p><i class="iconfont">&#xe60e;</i>关于逛球街</p>
				</nuxt-link>
				<nuxt-link to="../guanyu/disclaimer">
					<p><i class="iconfont">&#xe60f;</i>免责声明</p>
				</nuxt-link>
				<nuxt-link to="../guanyu/contact">
					<p><i class="iconfont">&#xe6ec;</i>联系方式</p>
				</nuxt-link>
			</div>
			<div class="gy-right">
				<div class="r-title">网站地图</div>
				<div class="r-content">

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				headCon: headCon()
			}
		},
		beforeMount() {
			var wx_login_t = this.$route.query.wx_login_t;
			if(wx_login_t){
				var href = location.href;
				if(location.href.indexOf("&") == -1){
					href = href.replace("?wx_login_t="+wx_login_t,"");
				}else{
					href = href.replace("&wx_login_t="+wx_login_t,"");
					href = href.replace("wx_login_t="+wx_login_t+"&","");
				}
				history.pushState("", "", href);
			}
		},
		mounted() {
			$("footer").show();
		},
		metaInfo() {
			return {
				title: this.headCon["guanyu"]["map"]["title"],
				meta: [{
						hid: "description",
						name: "description",
						content: this.headCon["guanyu"]["map"]["description"]
					},
					{
						hid: "keywords",
						name: 'keywords',
						content: this.headCon["guanyu"]["map"]["keywords"]
					}
				]
			};
		},
	}
</script>

<style scoped>
	@import "../../assets/css/guanyu.css";
</style>